
<script> 
    import Header from './Header.vue'
    import LeftMenu from './LeftMenu.vue'
    import { mapState,mapActions } from 'vuex'
    import Filters from './Filters.vue'
    import {isEmpty} from 'lodash';
    import { toRaw } from 'vue';
    import DownloadDialog from './DownloadDialog.vue';
    import TwoFaDialog from './TwoFaDialog.vue';
    import ScheduledReportsToEmail from './ScheduledReportsToEmail.vue';
    import {
        ADV_METRIC_FIELDS,
        KEYWORD_DIMENSION_FIELDS,
        PRODUCT_DIMENSION_FIELDS
    } from '../constants'
    import { getFilters, saveAndScheduleReport, downloadReport, getCookie, getQueryParam, 
        getDefaultReport,generateOtp, getLoggedSellerId,
     } from '../services/campaignService'
    import moment from 'moment';
    import ConfirmationModal from './ConfirmationModal.vue'

    export default {
        name: 'SaveAndScheduleReport',
        components: {
            Header,
            LeftMenu,
            ConfirmationModal,
            Filters,
            DownloadDialog,
            ScheduledReportsToEmail,
            TwoFaDialog
        },
        props:{
            // advancedReport: Boolean,
            savedReportScreen: Boolean,
            title: String
        },
        data(){
            return {
                mountedFinished:false,
                showOTPDialog: false, 
                reportEntity: null,
                dimensionFields: null,
                metricFields: null,
                reportName: this.reportDataFromLocal?.reportMetaData?.reportName ? this.reportDataFromLocal?.reportMetaData?.reportName : !this.advancedReport ? this.reportEntity?.reportMetaData?.reportName : null,
                reportType: this.reportDataFromLocal?.reportType ? this.reportDataFromLocal?.reportType : null,
                filters: {},
                options: ['once', 'daily', 'weekly','monthly'],
                frequency: this.reportDataFromLocal?.scheduleDetails?.frequency ? this.reportDataFromLocal?.scheduleDetails?.frequency.toLowerCase() : 'once',
                startDate: this.reportEntity?.dateFilter?.fromDate,
                endDate: this.reportEntity?.dateFilter?.toDate,
                displayEndDate: null,
                showCustomDate: false,
                showDateRangeFilter: false,
                dateFilterType: this.reportDataFromLocal?.dateFilter?.dateFilterType ? this.reportDataFromLocal?.dateFilter?.dateFilterType : !this.advancedReport && this.reportEntity?.dateFilter?.dateFilterType ? this.onDateRangeApply(this.reportEntity?.dateFilter?.dateFilterType) : 'Last 1 day',
                dateFilterKey: this.reportDataFromLocal?.dateFilter?.dateFilterType ? this.reportDataFromLocal?.dateFilter?.dateFilterType : !this.advancedReport && this.reportEntity?.dateFilter?.dateFilterType ? this.reportEntity?.dateFilter?.dateFilterType : 'LAST_1D',
                scheduleEndDate: this.reportDataFromLocal?.scheduleDetails?.endDate ?  this.formatDate(this.reportDataFromLocal?.scheduleDetails?.endDate) : null,
                scheduleStartDate: this.reportDataFromLocal?.scheduleDetails?.startDate ? this.formatDate(this.reportDataFromLocal?.scheduleDetails?.startDate) : null,
                showConfirmationModal: false,
                warnMessage: 'Discard will permanantly delete any changes made to this form',
                sellerId: '',
                checkedFilters: {},
                previousValues: {},
                isRegenerate: false,
                reportDataFromLocal: this.reportData, // JSON.parse(localStorage.getItem('reportData')),
                maxDate: '',
                validationErrorMessage: null,
                filtersValidationErrorMessage: null,
                advancedReport: this.advancedReport, //JSON.parse(localStorage.getItem('advancedReport')),
                emailIds: [],
                role: getCookie('role'),
                todayDate: null,
            }
        },
        computed: {
            ...mapState(['advancedReportBool','reportData', 'savedReportsEditMode']),
            dimensionsCheckboxes() {
                if(this.reportEntity?.dimensionFields){
                    return Object.keys(this.reportEntity?.dimensionFields).map(key => {
                        return {
                            label: key,
                            checked: this.reportEntity?.dimensionFields[key]
                        }
                    });
                }
                return
            },
            metricsCheckboxes() {
                if(this.reportEntity?.metricFields){
                    return Object.keys(this.reportEntity?.metricFields).map(key => {
                        return {
                            label: key,
                            checked: this.reportEntity?.metricFields[key]
                        }
                    });
                }
                return
            },
            startDateFormatted: {
                get() {
                    return this.startDate ? this.startDate.substring(0, 10) : null;
                },
                set(val) {
                    this.startDate = val ? `${val}T00:00:00.000Z` : null;
                }
            },
            endDateFormatted: {
                get() {
                    return this.displayEndDate ? moment.utc(this.displayEndDate).format('YYYY-MM-DD').substring(0,10) : moment.utc(this.endDate).format('YYYY-MM-DD').substring(0,10);
                },
                set(val) {
                    this.endDate = val ? `${val}T00:00:00.000Z` : null;
                }
            },
            disableFutureDate() {
                return moment().subtract(1, 'days').format('YYYY-MM-DD');
            },
        },

        watch: {
            startDate(newVal, oldVal){
                let startDate = new Date(newVal), endDate = new Date(this.endDate)
                if(endDate < startDate){
                    this.endDate = null;
                }
            },
            dimensionFields(newVal, oldVal){
                this.previousValues ={
                    'dimensionFields': toRaw(newVal), 
                    'reportName': this.reportName,
                    'frequency': this.frequency,
                    'dateFilterType': this.dateFilterType,
                    'startDate': this.startDate,
                    'endDate': this.endDate,
                    'scheduleStartDate': this.scheduleStartDate,
                    'scheduleEndDate': this.scheduleEndDate,
                    'metricFields': this.metricFields,
                    'checkedFilters': this.checkedFilters
                }
                this.dimensionFields = toRaw(newVal)
            },
            metricFields(newVal, oldVal){
                this.metricFields = toRaw(newVal)
                this.previousValues ={
                    'dimensionFields': this.dimensionFields, 
                    'reportName': this.reportName,
                    'frequency': this.frequency,
                    'dateFilterType': this.dateFilterType,
                    'startDate': this.startDate,
                    'endDate': this.endDate,
                    'scheduleStartDate': this.scheduleStartDate,
                    'scheduleEndDate': this.scheduleEndDate,
                    'metricFields': toRaw(newVal),
                    'checkedFilters': this.checkedFilters
                }
            },
        },
            
        mounted(){
            this.onGetDefaultReport();
            this.onGetFilters()
            let params = this.$route.query.advancedReport
            this.advancedReport = this.advancedReportBool
            // if(params){
            //     this.advancedReport = true;
            // }
            this.reportDataFromLocal = this.reportData, //JSON.parse(localStorage.getItem('reportData'))
            this.dimensionFields = this.reportEntity?.dimensionFields
            this.metricFields = this.reportEntity?.metricFields
            this.scheduleEndDate = this.reportDataFromLocal?.scheduleDetails?.endDate ? this.formatDate(this.reportDataFromLocal?.scheduleDetails?.endDate) : null;
            this.scheduleStartDate = this.reportDataFromLocal?.scheduleDetails?.startDate ? this.formatDate(this.reportDataFromLocal?.scheduleDetails?.startDate) : null;
            this.emailIds = this.reportData?.scheduleDetails?.emailIds?.length> 0 ? this.reportData?.scheduleDetails?.emailIds : [],
            this.frequency = this.reportDataFromLocal?.scheduleDetails?.frequency ? this.reportDataFromLocal?.scheduleDetails?.frequency.toLowerCase() : 'once';
            this.reportName = this.reportDataFromLocal?.reportMetaData?.reportName ? this.reportDataFromLocal?.reportMetaData?.reportName : !this.advancedReport ? this.reportEntity?.reportMetaData?.reportName : null
            this.reportType = this.reportDataFromLocal?.reportType ? this.reportDataFromLocal?.reportType : !this.advancedReport && this.reportEntity?.reportType ? this.reportEntity?.reportType : null
            this.dateFilterKey = this.reportDataFromLocal?.dateFilter?.dateFilterType ? this.reportDataFromLocal?.dateFilter?.dateFilterType : !this.advancedReport && this.reportEntity?.dateFilter?.dateFilterType ? this.reportEntity?.dateFilter?.dateFilterType : 'LAST_1D';
            this.startDate = this.reportDataFromLocal?.dateFilter?.fromDate ? this.reportDataFromLocal?.dateFilter?.fromDate : this.reportEntity?.dateFilter?.fromDate ? this.reportEntity?.dateFilter?.fromDate : null,
            this.endDate = this.reportDataFromLocal?.dateFilter?.toDate ? this.reportDataFromLocal?.dateFilter?.toDate : this.reportEntity?.dateFilter?.toDate ? this.reportEntity?.dateFilter?.toDate : null;
            this.showCustomDate = false
            if(this.reportDataFromLocal?.dateFilter?.dateFilterType === 'CUSTOM' || this.reportEntity?.dateFilter?.dateFilterType === 'CUSTOM'){
                this.onDateRangeApply('CUSTOM_DATE');
            }
            this.previousValues ={
                'reportName': this.reportName,
                'frequency': this.frequency,
                'dateFilterType': this.dateFilterType,
                'startDate': this.startDate,
                'endDate': this.endDate,
                'scheduleStartDate': this.scheduleStartDate,
                'scheduleEndDate': this.scheduleEndDate,
                'dimensionFields': this.dimensionFields,
                'metricFields': this.metricFields,
                'checkedFilters': this.checkedFilters,
            }
            this.sellerId = getLoggedSellerId();

            var dtToday = new Date();
            
            var month = dtToday.getMonth() + 1;
            var day = dtToday.getDate() + 1;
            var year = dtToday.getFullYear();
            if(month < 10)
                month = '0' + month.toString();
            if(day < 10)
            day = '0' + day.toString();
            this.maxDate = year + '-' + month + '-' + day;

            this.resetReportEntityId();
            // localStorage.removeItem('reportEntityId')
            this.mountedFinished = true;
            this.todayDate = moment().format('YYYY-MM-DD');
        },
       
        methods: {
            ...mapActions(['resetReportData','setReportData','resetReportEntityId','setReportEntityId']),
            onGenerateOtp(){
                generateOtp()
            },
            disableMetrics(value){
                if(value === 'add to cart' || value === 'pdp count' || value === 'viewable impressions'){
                    return true
                }
            },
            async onGetFilters(){
                await getFilters()
                .then(res=>res.json())
                .then(data => {
                    if(this.advancedReport){
                        delete data?.filters?.CAMPAIGN_STATUS;
                        delete data?.filters?.PLACEMENT_CATEGORY;
                        delete data?.filters?.TARGETING_TYPE;
                        delete data?.filters?.CREATED_BY;
                        this.filters = data?.filters
                    }else{
                        this.filters = data?.filters
                    }
                })
            },
            async onGetDefaultReport(){
                await getDefaultReport()
                .then(res => res.json())
                .then(data => {
                    this.emailIds = this.reportData?.scheduleDetails?.emailIds;
                    this.reportEntity = this.reportData?.reportType === 'CAMPAIGN_PERFORMANCE_REPORT' ? this.reportData : data?.reportEntity
                    this.reportName = this.reportDataFromLocal?.reportMetaData?.reportName ? this.reportDataFromLocal?.reportMetaData?.reportName : !this.advancedReport ? data?.reportEntity?.reportMetaData?.reportName : this.reportName
                    data?.reportEntity && !this.advancedReport ? this.onDateRangeApply(data?.reportEntity?.dateFilter?.dateFilterType) : null;
                    this.reportType = this.reportDataFromLocal?.reportType ? this.reportDataFromLocal?.reportType : !this.advancedReport && this.reportEntity?.reportType ? this.reportEntity?.reportType : null
                    this.dimensionFields = data?.reportEntity?.dimensionFields
                    this.metricFields = data?.reportEntity?.metricFields
                    this.scheduleStartDate = this.reportDataFromLocal?.scheduleDetails?.startDate ? this.formatDate(this.reportDataFromLocal?.scheduleDetails?.startDate) : !this.advancedReport ? this.formatDate(data?.reportEntity?.scheduleDetails?.startDate) : this.scheduleStartDate
                    this.scheduleEndDate = this.reportDataFromLocal?.scheduleDetails?.endDate ? this.formatDate(this.reportDataFromLocal?.scheduleDetails?.endDate) : !this.advancedReport ? this.formatDate(data?.reportEntity?.scheduleDetails?.endDate) : this.scheduleEndDate
                    //this.emailIds = this.reportData?.scheduleDetails?.emailIds.length> 0 ? this.reportData?.scheduleDetails?.emailIds : [],
                    this.startDate = this.advancedReportBool ?this.reportDataFromLocal?.dateFilter?.fromDate : this.reportEntity?.dateFilter?.fromDate
                    this.endDate = this.advancedReportBool ?this.reportDataFromLocal?.dateFilter?.toDate : this.reportEntity?.dateFilter?.toDate
                    if( this.reportDataFromLocal?.dateFilter?.dateFilterType === 'CUSTOM' || (!this.advancedReport && this.reportEntity?.dateFilter?.dateFilterType === 'CUSTOM')){
                        this.dateFilterKey = 'CUSTOM'
                        this.displayEndDate = moment.utc(this.endDate).subtract(1, 'day').format('YYYY-MM-DD');
                        this.dateFilterType =  this.formatDate(this.startDate) + " - " + this.formatDate(this.displayEndDate ? this.displayEndDate : '');
                    }
                    if(!this.advancedReport && this.reportEntity) {
                        this.checkedFilters = this.reportEntity?.filters
                    } else if((this.advancedReport && !this.reportDataFromLocal) || (!this.advancedReport && !this.reportDataFromLocal)){
                        this.checkedFilters = {}
                    }else if((this.advancedReport && this.reportDataFromLocal) || (!this.advancedReport && this.reportDataFromLocal)){
                        this.checkedFilters = !this.isEmptyObject(this.reportDataFromLocal) ? this.reportDataFromLocal?.filters : {}
                    }
                    if(this.reportDataFromLocal){
                        !this.isEmptyObject(this.reportDataFromLocal) ? this.onDateRangeApply(this.reportDataFromLocal?.dateFilter?.dateFilterType) : null
                    }
                });
            },
            checkInputChange(inputName) {
                if (inputName === 'scheduleStartDate' && this[inputName] !== this.previousValues[inputName]) {
                    this.scheduleEndDate = null
                }
            },
            onDiscardClick(){
                this.showConfirmationModal = !this.showConfirmationModal
            },
            onclear(filterName){
                this.checkedFilters[filterName] = [];
            },
            onSelectAll(filterName, value) {
                this.checkedFilters[filterName] = [...value];
            },
            onFilterChange(data){
                this.filtersValidationErrorMessage = null
                if (this.checkedFilters === null) {
                    this.checkedFilters = {}; // Initialize as an empty object
                }
                if(this.checkedFilters?.hasOwnProperty(data.filterName)){
                    if(this.checkedFilters[data.filterName].includes(data.value)){
                        const updatedData = Object.fromEntries(
                                Object.entries(this.checkedFilters).map(([key, value]) => {
                                    if (key === data.filterName) {
                                        return [key, value.filter(item => item !== data.value)];
                                    }
                                        return [key, value];
                                })
                            );
                            this.checkedFilters = Object.fromEntries(
                                Object.entries(updatedData).filter(([key, value]) => value.length > 0)
                            );
                    }else{
                        this.checkedFilters[data.filterName].push(data.value)
                    }
                }else{
                    this.checkedFilters[data.filterName] = [data.value]
                }
            },
            clearData() {
                Object.assign(this.$data, this.$options.data.call(this));
                this.reportName = null
                if(this.savedReportScreen){
                    this.$router.go(-1)
                }else{
                    this.$router.push({
                        path: `${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/analytics`,
                    })
                }
            },
            onCloseModal() {
                this.showConfirmationModal = false
            },

            isEmptyObject(obj) {
                if(obj){
                    return Object.keys(obj).length === 0;
                }
            },
            onBackBtnClick(){
                this.$router.push({
                    path: `${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/analytics`,
                })
            },
            onDateRangeClick(){
                this.showDateRangeFilter = !this.showDateRangeFilter
            },
            onDateRangeApply(dateFilterType){
                if(dateFilterType === 'CUSTOM' ){
                    this.showCustomDate = !this.showCustomDate;
                    return
                }
                if(dateFilterType === 'LAST_1D'){
                    this.dateFilterType = 'Last 1 day';
                    this.dateFilterKey = 'LAST_1D';
                    this.checkInputChange('dateFilterType')
                    this.startDate = this.endDate = null;
                }else if(dateFilterType === 'LAST_7D'){
                    this.dateFilterKey = 'LAST_7D';
                    this.dateFilterType = 'Last 1 week';
                    this.checkInputChange('dateFilterType')
                    this.startDate = this.endDate = null;
                }else if(dateFilterType === 'LAST_30D'){
                    this.dateFilterKey = 'LAST_30D';
                    this.dateFilterType = 'Last 1 month';
                    this.checkInputChange('dateFilterType')
                    this.startDate = this.endDate = null;
                }else if(dateFilterType === 'CURRENT_MONTH'){
                    this.dateFilterKey = 'CURRENT_MONTH';
                    this.dateFilterType = 'Current month';
                    this.checkInputChange('dateFilterType')
                    this.startDate = this.endDate = null;
                }else if(this.reportDataFromLocal?.dateFilter?.dateFilterType === 'CUSTOM' || this.reportEntity?.dateFilter?.dateFilterType === 'CUSTOM'){
                    this.dateFilterKey = 'CUSTOM';
                    this.dateFilterType = this.formatDate(this.startDate) + " - " + this.formatDate(this.endDate);
                    this.startDate = this.startDate ? (moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                    this.displayEndDate = this.endDate ? this.endDate : null;
                    this.endDate = this.endDate ? (moment.utc(this.endDate).add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                }else{
                    this.dateFilterKey = 'CUSTOM';
                    this.dateFilterType = this.formatDate(this.startDate) + " - " + this.formatDate(this.endDate);
                    this.startDate = this.startDate ? (moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                    this.displayEndDate = this.endDate ? this.endDate : null;
                    this.endDate = this.endDate ? (moment.utc(this.endDate).add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                }
                this.showDateRangeFilter = false;
            },
            convertData(value) {
                const data = {};
                value?.forEach(checkbox => {
                    data[checkbox.label] = checkbox.checked;
                });
                return data;
            },
            formatDate(value) {
                if (value) {
                    return moment.utc(String(value)).format('YYYY-MM-DD');
                }
            },
            areObjectsEqual(obj1, obj2) {
                const values1 = obj1 && Object.values(obj1);
                const values2 = obj2 && Object.values(obj2);

                if (values1?.length !== values2?.length) {
                    return false;
                }

                const sortedValues1 = values1?.sort();
                const sortedValues2 = values2?.sort();

                for (let i = 0; i < sortedValues1?.length; i++) {
                    if (sortedValues1[i] !== sortedValues2[i]) {
                        return false;
                    }
                }

                return true;
            },

            compareObjects(obj1, obj2) {
                if(obj1 === null){
                    return
                }
                if(obj2 === null)
                obj2={};
                const keys = Object.keys(obj1);

                for (let key of keys) {
                    const value1 = obj1[key];
                    const value2 = obj2[key];

                    if (Array.isArray(value1) && Array.isArray(value2)) {
                    if (value1.length !== value2.length) {
                        return false;
                    }

                    for (let i = 0; i < value1.length; i++) {
                        if (value1[i] !== value2[i]) {
                        return false;
                        }
                    }
                    }
                    else {
                    if (value1 !== value2) {
                        return false;
                    }
                    }
                }

                return true;
            },
            async onDownloadClick(){
                await this.onSaveAndScheduleReport(true)
                if(this.advancedReport && !this.filters){
                    this.filtersValidationErrorMessage = 'No data available';
                    return false
                }else if(this.advancedReport && (!this.checkedFilters || !this.checkedFilters.hasOwnProperty('CAMPAIGN_ID') || this.checkedFilters['CAMPAIGN_ID'].length < 1)){
                    this.filtersValidationErrorMessage = 'Select atleast one CAMPAIGN_ID';
                    return false
                }
                if(isEmpty(this.validationErrorMessage) && isEmpty(this.filtersValidationErrorMessage)){
                    this.showOTPDialog = true;
                }

                // downloadReport(this.reportEntity?.reportEntityId)
                // .then(res=>res.json())
                // .then(data=>{
                //     data?.signed_urls.map(url=> {
                //         window.open(url);
                //     })
                // })
            },
            onCancelOTP() {
                this.showOTPDialog = false;
            },
            onGetEmailIds(value){
                this.emailIds = value;
            },
            async onSaveAndScheduleReport(isDownload){
                let isAdvReportFromHomepage;
                let dimensionFields,metricFields;
                if (this.advancedReport) {
                    if (this.reportType) {
                        dimensionFields = this.reportType == "KEYWORD_PERFORMANCE_REPORT" ? KEYWORD_DIMENSION_FIELDS : PRODUCT_DIMENSION_FIELDS;
                        metricFields = ADV_METRIC_FIELDS;
                    }
                } else {
                    dimensionFields = this.convertData(this.dimensionsCheckboxes);
                    metricFields = this.convertData(this.metricsCheckboxes);
                }

                if(this.advancedReport && !this.reportDataFromLocal?.reportEntityId){
                    isAdvReportFromHomepage = true
                }else if(this.reportDataFromLocal?.reportEntityId){
                    this.reportEntity = this.reportDataFromLocal;
                    isAdvReportFromHomepage = false
                }else{
                    isAdvReportFromHomepage = false
                }

                //checking if any input field has been changed
                if(this.dateFilterType !== this.previousValues.dateFilterType ||
                    this.startDate !== this.previousValues.startDate ||
                    this.endDate !== this.previousValues.endDate ||
                    this.scheduleStartDate !== this.previousValues.scheduleStartDate ||
                    this.scheduleEndDate !== this.previousValues.scheduleEndDate ||
                    this.frequency !== this.previousValues.frequency ||
                    !this.areObjectsEqual(dimensionFields, this.previousValues.dimensionFields) || 
                    !this.areObjectsEqual(metricFields, this.previousValues.metricFields)||
                    !this.compareObjects(this.checkedFilters, this.previousValues.checkedFilters)
                ){
                    this.isRegenerate = true;
                }else{
                    this.isRegenerate = false;
                }

                this.previousValues = {
                    reportName: this.reportName,
                    dateFilterType: this.dateFilterType,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    scheduleStartDate: this.scheduleStartDate,
                    scheduleEndDate: this.scheduleEndDate,
                    frequency: this.frequency,
                    dimensionFields: dimensionFields,
                    metricFields: metricFields,
                    checkedFilters: this.checkedFilters
                }
                let isSaved;
              
                if(isAdvReportFromHomepage && isDownload){
                    isSaved = false
                }else if(isAdvReportFromHomepage && !isDownload){
                    isSaved = true
                }else {
                    isSaved = true
                }

                // let dimensionFields = this.advancedReport ?  : this.convertData(this.dimensionsCheckboxes)
                let params = {
                    "reportEntityId": isAdvReportFromHomepage ? null : this.reportEntity?.reportEntityId,
                    "dateFilter": {
                        "fromDate": this.startDate ?(moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : this.reportEntity?.dateFilter?.fromDate,
                        "toDate": this.endDate ? (moment.utc((this.endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')): this.reportEntity?.dateFilter?.toDate,
                        "dateFilterType": this.dateFilterKey
                    },
                    "reportType": this.reportType, 
                    "isRegenerate": isAdvReportFromHomepage ? true : this.isRegenerate,
                    "reportMetaData": {
                        "loggedInEmail": isAdvReportFromHomepage || !this.savedReportsEditMode ? getCookie('userEmail') : this.reportEntity?.reportMetaData?.loggedInEmail,
                        "loggedInRole": isAdvReportFromHomepage || !this.savedReportsEditMode ? getCookie('role') : this.reportEntity?.reportMetaData?.loggedInRole,
                        "sellerId": this.sellerId,
                        "reportName": this.reportName,
                        "gcpReportNamePrefix": isAdvReportFromHomepage ? null : this.reportEntity?.reportMetaData?.gcpReportNamePrefix,
                        "isSaved":  isSaved,
                        "creationDate": isAdvReportFromHomepage ? null : this.reportEntity?.reportMetaData?.creationDate,
                        "signedURLs":  isAdvReportFromHomepage ? null : this.reportEntity?.reportMetaData?.signedURLs,
                        "urlExpiryTs": isAdvReportFromHomepage ? null : this.reportEntity?.reportMetaData?.urlExpiryTs,
                        "totalNumOfRows": isAdvReportFromHomepage ? 0 : this.reportEntity?.reportMetaData?.totalNumOfRows
                    },
                    "dimensionFields": dimensionFields,
                    "metricFields": metricFields,
                    "filters": !isEmpty(this.checkedFilters) ? this.checkedFilters : null,
                    "scheduleDetails": {
                        frequency: (this.frequency).toUpperCase(),
                        startDate: this.scheduleStartDate,
                        endDate: this.scheduleEndDate,
                        emailIds: this.emailIds
                    },
                    "isDefault": isAdvReportFromHomepage? false : this.reportEntity?.isDefault
                }

                if(this.validateParams(params)){
                    await saveAndScheduleReport(params)
                    .then((res) => {
                        if(res.status === 200 || res.status === 201){
                            !isDownload ? this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/saved-reports`) : null
                        }
                        return res.json()
                    })
                    .then(data => {
                        this.setReportEntityId(data?.reportEntityId)
                        //localStorage.setItem('reportEntityId', data?.reportEntityId)
                        this.reportEntityId = data?.reportEntityId
                    })
                }

            },

            validateParams(params){
                let name = params.reportMetaData.reportName, dateFilterType = params.dateFilter.dateFilterType, fromDate = params.dateFilter.fromDate, toDate = params.dateFilter.toDate,
                reportType = params.reportType, scheduleEndDate = params?.scheduleDetails?.endDate, scheduleStartDate = params?.scheduleDetails?.startDate,
                frequency = params.scheduleDetails.frequency;

                if(frequency !== 'ONCE' && (isEmpty(scheduleStartDate) || isEmpty(scheduleEndDate))){
                    this.validationErrorMessage = 'Required Field';
                    return false
                }
                if(this.advancedReport && !this.filters){
                    this.filtersValidationErrorMessage = 'No data available';
                    return false
                }else if(this.advancedReport && (!params.filters || !params.filters.hasOwnProperty('CAMPAIGN_ID') || params.filters['CAMPAIGN_ID'].length < 1)){
                    this.filtersValidationErrorMessage = 'Select atleast one CAMPAIGN_ID';
                    return false
                }
                if(dateFilterType === 'CUSTOM'){
                    if(isEmpty(fromDate) && isEmpty(toDate)){
                        this.validationErrorMessage = 'Required Field';
                        return false
                    }
                }else if(isEmpty(dateFilterType)){
                    this.validationErrorMessage = 'Required Field';
                    return false
                }
                if(!isEmpty(scheduleStartDate) && isEmpty(scheduleEndDate)){
                    this.validationErrorMessage = 'Required Field';
                    return false
                }
                if(this.advancedReport && isEmpty(reportType)){
                    this.validationErrorMessage = 'Required Field';
                    return false
                }
                if(isEmpty(name)){
                    this.validationErrorMessage = 'Required Field';
                    return false
                }
                this.validationErrorMessage = '';
                return true
            },
        },
    }
</script>

<template>
    <div> 
        <div class="saveContainerWrapper">
            <div class="middlecontainer">
                <!-- <LeftMenu /> -->
                <div class="scheduleReportsContainer">
                    <div class="headerWrapper"> 
                        <div class="titleWrapper"> 
                            <img @click="onBackBtnClick" alt="img" class="arrow" src="../assets/backArrow.svg">
                            <div v-if="this.advancedReport" class="title">Advanced Reports</div>
                            <div v-else class="title">Save and Schedule Report </div>
                        </div>
                        <div class="btnWrapper" v-if="!(reportData?.reportMetaData?.loggedInRole == 'AGENCY' && role !== 'AGENCY')"> 
                            <div class="saveBtn" @click="onSaveAndScheduleReport(false)"> Save </div>
                            <div class="discardBtn" @click="onDiscardClick">Discard</div>
                        </div>
                    </div> 
                    <div v-if="(this.advancedReport && (!checkedFilters || !checkedFilters.hasOwnProperty('CAMPAIGN_ID') || checkedFilters['CAMPAIGN_ID'].length < 1) && this.filtersValidationErrorMessage)" style=" margin-bottom: 1%" class="errorContainer" > 
                        <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.filtersValidationErrorMessage }}</div>
                    </div>
                    <div :class="`${reportData?.reportMetaData?.loggedInRole == 'AGENCY' && role !== 'AGENCY' ? 'pointerEvents' : ''} container`"> 
                        <div class="containerWrapper"> 
                            <div class="heading">Generate Report</div>
                        </div>  
                        <div class="inputContainer" style="padding-bottom: 100px;"> 
                            <div class="containerWrapper"> 
                                <div v-if="(!this.reportName && this.validationErrorMessage)" style=" margin-bottom: 1%" class="errorContainer"> 
                                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                                </div>
                                <div class="name">Report Name</div>
                                <input class="textbox" @input="checkInputChange('reportName')" name="reportName" v-model="reportName"  placeholder="Name of the report" />
                                <!-- DateRange -->
                                <div v-if="(!this.dateFilterType && this.validationErrorMessage)" style=" margin-bottom: 1%" class="errorContainer"> 
                                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                                </div>
                                <div class="name">Date Range</div>
                                <div class="dateRangeWrapper"> 
                                    <div @click="onDateRangeClick" class="dateRange">{{ dateFilterType }}
                                        <img class="arrowIcon" alt="img" src="../assets/arrowIcon.svg" />
                                    </div>
                                    <div class="dateRangeContainer" v-if="showDateRangeFilter">
                                        <div class="dateText" @click="onDateRangeApply('CUSTOM')">Custom</div>
                                        <div v-if="!showCustomDate" class="applyClass"> 
                                            <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" @input="checkInputChange('startDate')" v-model="startDateFormatted" >
                                            <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" @input="checkInputChange('endDate')" v-model="endDateFormatted" :min="startDateFormatted" :max="todayDate">
                                            <div v-if="this.startDate && this.endDate" class="applyBtn" @click="onDateRangeApply"> Apply </div>
                                        </div>
                                        <div class="dateText" @click="onDateRangeApply('LAST_1D')">Last 1 day</div>
                                        <div class="dateText" @click="onDateRangeApply('LAST_7D')">Last 1 week</div>
                                        <div class="dateText" @click="onDateRangeApply('LAST_30D')">Last 1 month</div>
                                        <div class="dateText" @click="onDateRangeApply('CURRENT_MONTH')">Current month</div>
                                    </div>
                                </div>
                                <div v-if="(advancedReport && !this.reportType && this.validationErrorMessage)" style=" margin-bottom: 1%" class="errorContainer"> 
                                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                                </div>
                                <div class="reportType" v-if="advancedReport">
                                    <div class="name">Choose a report</div>
                                    <input type="radio" value="PRODUCT_PERFORMANCE_REPORT" id="product" v-model="reportType"/>
                                    <label for="product" class="reportTypeName" style="margin-right: 30px">Product Performance</label>
                                    <input type="radio" value="KEYWORD_PERFORMANCE_REPORT" id="keyword" v-model="reportType"/>
                                    <label for="keyword" class="reportTypeName">Targeting Performance</label>
                                </div>

                                <!-- Fields -->
                                <div class="fields" v-if="!advancedReport"> 
                                    <div class="name"> Add Fields </div>
                                    <div class="checkboxes"> 
                                        <div class="dimensions"> 
                                            <div class="subTitle">Dimensions</div>
                                            <div v-for="(checkbox, index) in dimensionsCheckboxes" :key="index" style="margin-bottom: 15px"> 
                                                <div class="text"> 
                                                    <input name="date" type="checkbox" class="checkbox" :id="'dimension-' + index" @input="checkInputChange('dimensionFields')" v-bind:checked="checkbox.checked"  v-model="checkbox.checked">
                                                    <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="metrics"> 
                                            <div class="subTitle">Metrics</div>
                                            <div v-for="(checkbox, index) in metricsCheckboxes" :key="index" style="margin-bottom: 15px">
                                                <div class="text"> 
                                                    <input name="date" type="checkbox" class="checkbox" :id="'metric-' + index" :disabled="disableMetrics(checkbox.label.replace(/_/g, ' ').toLowerCase())"   @input="checkInputChange('metricFields')"  v-bind:checked="checkbox.checked" v-model="checkbox.checked">
                                                    <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Filters -->
                            <div class="containerWrapper"> 
                                <div v-if="filters" class="name addfilters"> Add Filters </div>
                                <div class="filtersWrapper"> 
                                    <div v-for="(value, key) in filters" :key="key" > 
                                        <Filters 
                                            :filter="key"
                                            :value="value"
                                            @onFilterChange="onFilterChange"
                                            :prefillValue="this.checkedFilters?.[key]"
                                            :count="this.checkedFilters?.[key]?.length"
                                            @onClear="onclear"
                                            @onSelectAll="onSelectAll"
                                        />
                                    </div>
                                </div>
                                <div v-if="advancedReport" class="downloadReport" @click="onDownloadClick">Download Report</div>
                            </div>
                            
                            <!-- Schedule report -->
                            <div class="containerWrapper">
                                <div class="heading">Schedule Report</div>
                            </div>
                            <div v-if="(((this.scheduleStartDate && !this.scheduleEndDate)) || (this.frequency !== 'once' && (!scheduleStartDate || !scheduleEndDate)) && this.validationErrorMessage)" style=" margin-bottom: 1%" class="errorContainer"> 
                                <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                            </div>
                            <div class="contentWrapper"> 
                                <div class="scheduleTitle">Duration</div>
                                <div class="calendar">
                                    <input class="date" type="date" style="margin-right: 12px; cursor: pointer; width: 130px;" placeholder="Start Date" @input="checkInputChange('scheduleStartDate')" v-model="scheduleStartDate" :min="maxDate">
                                    <div style="margin: 0 13px">to</div>
                                    <input class="date" type="date" id="toDate"  style="margin-right: 12px; cursor: pointer; width: 130px;" placeholder="end Date"  :min="scheduleStartDate"  @input="checkInputChange('scheduleEndDate')" v-model="scheduleEndDate">
                                </div>
                                <div class="scheduleTitle">Frequency</div>
                                <select v-model="frequency" @input="checkInputChange('frequency')" class="frequency">
                                    <option v-for="option in options" v-bind:key="option" :value="option">{{option}}</option>
                                </select>
                            </div>
                            <div v-if="mountedFinished">
                                <ScheduledReportsToEmail :prefillEmailIds="this.reportDataFromLocal?.scheduleDetails?.emailIds?.length > 0 ?this.reportDataFromLocal?.scheduleDetails?.emailIds : null " @emailIds="onGetEmailIds"> </ScheduledReportsToEmail>
                            </div>
                        </div>
                    </div>
                    <div v-if="showConfirmationModal">
                        <ConfirmationModal @buttonClicked="clearData" :warnMessage='warnMessage' :leftButton="'Cancel'" :rightButton="'Discard'"
                            @cancelClicked="onCloseModal" />
                    </div>
                    <TwoFaDialog
                        v-if="showOTPDialog"
                        downloadReport
                        @cancel="onCancelOTP"
                        :reportEntityId="this.reportEntityId"
                        :advancedReport="this.advancedReport"
                    />
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    .reportTypeName{
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #41434C;
        padding-left: 8px;
    }

    .dateRangeWrapper{
        position: relative;
    }

    .dateRange {
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 210px;
        padding: 9px 18px 9px 15px;
        color: rgba(#41434C, 0.8);
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        margin-right: 12px;
        cursor: pointer;
        margin-bottom: 32px;

    }

    .arrowIcon {
        width: 8px;
        height: 5px;
        margin-left: 48px;
    }

    .errorContainer{
        background: #FDEDED;
        border-radius: 8px;
        /* margin: 2%; */
        margin-right: 1%;
        margin-bottom: unset;
        padding: 18px 24px;
        font-family: 'Inter-Regular';
        font-style: normal;
    }

    .errorHeading{
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
        color: #EB5757;
        /* margin-bottom: 12px; */
        display: flex;
    }
    .dateRangeContainer{
        min-width: 370px;
        position: absolute;
        top: 48px;
        z-index: 1;
        padding: 10px;
        border-radius: 4px;
        background: #FFFFFF;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }

    .dateFilter{
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 8px 16px 8px 10px;
        color: #41434C;
        opacity: 0.8;
        margin-right: 12px;
        cursor: pointer;
    }

    .applyBtn{
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #0004B5;
        opacity: 0.8;
        padding: 8px;
        border: 1px solid #0004B5;
        border-radius: 4px;
        cursor: pointer;
    }

    .dateText{
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
        cursor: pointer;
        margin-bottom: 20px;
    }

    .dateText:last-child{
        margin-bottom: unset;
    }

    .applyClass{
        display: flex;
        margin-bottom: 10px;
    }

    .downloadReport{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #2E31BE;
        padding: 9px 0;
        background: #FFFFFF;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        margin-right: 24px;
        cursor: pointer;
    }

    .saveContainerWrapper{
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .scheduleTitle{
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0em;
        color: #333333;
        margin-bottom: 12px;
        margin-top: 30px;
        font-family: "Inter-Regular";
    }

    .contentWrapper{
        padding: 0 0 44px 24px;
    }

    .calendar{
        display: flex;
        align-items: center;
        width: 100%;
    }

    .frequency{
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        text-transform: capitalize;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 14px;
        gap: 5px;
        width: 152px;
        height: 39px;
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
    }

    .addfilters{
        padding-top: 8px;
    }


    .filtersWrapper{
        display: flex;
        flex-wrap: wrap;
    }

    .filter{
        margin-bottom: 16px;
    }
    .filterName{
        font-weight: 400;
        font-size: 14.9343px;
        line-height: 25px;
        color: #41434C;
        opacity: 0.8;
        padding: 8px 12px 8px 15px;
        /* max-width: 162px; */
        margin-bottom: 18px;
        display: flex;
        background: #F5F5F5;
        border-radius: 17px;
        margin-right: 16px;
        width: 290px;
        display: flex;
        justify-content: space-between;

    }

    .subTitle{
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 26px;
        color: #3F3F3F;
        margin-bottom: 14px;
        padding-left: 14px;
    }

    .checkboxes{
        display: flex;
        padding-bottom: 54px;
    }

    .dimensions{
        padding-right: 55px;
        margin-right: 16px;
        border-right: 1px solid #F4F4F4;
    }

    .text{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #41434C;
        text-align: center;
        display: flex;
        align-items: center;
    }

    .downloadBtn{
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        width: 1060px;
        padding: 12px 0;
        text-align: center;
        background: #FFFFFF;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        color: #2E31BE;
        margin-top: 50px;
    }

    .date{
        width: 100%;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        max-width: 246px;
    }

    .textbox{
        width: 100%;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        max-width: 246px;
        margin-bottom: 32px;
    }

    label{
        color: #41434C;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
    }

    .checkbox{
        margin-right: 8px;
        width: 20px;
        height: 20px;
    }

    .name{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
        margin-bottom: 16px;
    }

    .container{
        margin-left: 20px;
        background: #FFFFFF;
        border-radius: 4px;
        height: auto;
    }

    .containerWrapper{
        padding: 20px 0 24px 24px;
        border-bottom: 1px solid #E0E0E0;
    }

    .heading{
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        color: #666666;
        /* padding: 24px 42px 20px;
        border-bottom: 1px solid #E0E0E0; */
    }


    .deleteIcon{
        margin: 0 30px;
    }
    .headerRow{
        display: flex;
        justify-content: space-between;
        padding: 22px 68px 22px 26px;
        background: #F7F7F7;
        border-radius: 4px;
    }

    .rowItem{
        display: grid;
        grid-template-columns: auto auto auto auto auto auto;
        justify-content: space-between;
        padding: 12px 20px 12px 50px;
    }

    .item{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 11.269px;
        line-height: 22px;
        color: #41434C;
        opacity: 0.8;
    }

    .rows{
        /* display: grid;
        grid-template-columns: auto auto auto auto auto auto; */
        max-width: 1146px;
        margin: 0 24px 20px;
        background: #FFFFFF;
        padding: 12px;
        border-radius: 4px;
        height: 100vh;
    }

    .rowtitle{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        color: #141414;
    }

    .scheduleReportsContainer{
        width: 100%;
        background: #F8F8F8;
    }

    .middlecontainer{
        font-family: 'Inter-Regular';
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    .titleWrapper{
        display: flex;
        align-items: center;
    }

    .arrow{
        margin-right: 15px;
        width: 18px;
        height: 14px;
        cursor: pointer;
    }
    .headerWrapper{
        display: flex;
        justify-content: space-between;
        padding: 24px 30px 20px 14px;
        margin-bottom: 22px;
        background: #FFFFFF;

    }

    .title{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #373737;
    }

    .saveBtn{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #FFFFFF;
        padding: 9px 50px;
        border: 1px solid #2E31BE;
        background: #2E31BE;
        border-radius: 4px;
        cursor: pointer;
        margin-right: 18px;
    }

    .btnWrapper{
        display: flex;
    }

    .discardBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #2E31BE;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        padding: 9px 46px;
        cursor: pointer;
    }
    .pointerEvents {
        pointer-events: none;
    }
</style>